import React from "react";

export default (props) => {
  return (
    <button type="button" className="btn btn-default" data-dismiss="modal">{props.text || 'Close'}</button>
  );
}
